<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<!--Display Trash or Normal Table View-->
				<h2>{{ $options.name }} - {{this.subTitle}}</h2>
			</b-col>
			<!--Gear Icon-->
			<b-col lg="6">
				<!-- <b-btn class="pull-right" v-b-popover.hover.top="'Select Datapoints'" variant="info" @click="configTable = true"><i class="fa fa-cog"></i></b-btn> -->
				<b-dropdown :disabled="edit" class="pull-right" right variant="info" no-caret>
					<template slot="button-content">
						<i class="fa fa-cog"></i>
					</template>
					<b-dropdown-item @click="edit_e">Edit</b-dropdown-item>
					<b-dropdown-item @click="delete_d">Delete</b-dropdown-item>
				</b-dropdown>
			</b-col>
		</div>

		<div>
			<b-card v-if="loadingData">
				<b-col cols="12" sm="12" md="12" lg="12">
					<p class="text-center">
						<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
					</p>
				</b-col>
			</b-card>
			<div v-else>
				<b-card v-if="found">
					<b-row>
                        <!-- @input="selects_trucking_company()" -->
						<b-col md="8">
                            <b-form-group :label-cols="4" id="L2" label="Energy Company Name" label-for="notif1" horizontal>
								<b-form-input v-if="!edit" class="plaintext-input" plaintext id="notif1" v-model="model.energy_company_name" type="text"></b-form-input>
								<b-form-select v-else id="notif1" value-field="id" text-field="name" v-model="model.energy_company_id" :options="company_name"/>       
							</b-form-group>
                            <b-form-group label="Email" label-for="notif2" :label-cols="4" horizontal>
                                 <b-form-input v-if="!edit" disabled type="email" v-model="model.email" class="form-control"/>
				                <b-form-input v-else type="email" v-model="model.email" class="form-control" @keypress.native="isLowerCaseEmail($event)"/>
			                </b-form-group>
                            <b-form-group :label-cols="4" id="L17" label="Activated" label-for="ULID" horizontal>
								<b-form-checkbox v-if="!edit"
                					id="ULID"
									class="custom-checkboxes"
                					v-model="model.activate" 
							  		style="margin-top: 13px;"
									disabled
              					></b-form-checkbox>	
								<b-form-checkbox v-else
                					id="ULID"
									class="custom-checkboxes"
                					v-model="model.activate" 
							  		style="margin-top: 13px;"
              					></b-form-checkbox>	
					  		</b-form-group>	
							<div slot="footer" v-show="edit">
								<b-button @click="update" size="sm" variant="primary"><i class="fa fa-edit"></i> Update</b-button>
								<b-button @click="edit_e" size="sm"><i class="fa fa-ban"></i> Cancel</b-button>
							</div>
						</b-col>
					</b-row>
					<!-- </b-tab> -->
				</b-card>
				<b-row v-else>
					<b-col cols="12" sm="12" md="12" lg="12">
						<br>
						<p class="text-center text-danger">
							<i class="icon fa-lg icon-puzzle"></i><br>{{notFoundMessage}}
						</p>
					</b-col>
				</b-row>
			</div>
		</div>
	</div>
</template>

<script>
	import service from './notification_service'
	export default {
		name: 'Request-Notification',
		created: function() {
			this.get_Data()
		},
		props: {
			id: {
                type        : String,
                default     : 0
			}
		},
		data() {
			return {
				subTitle        : '',
				edit            : false,
				found           : false,
				notFoundMessage : 'Not found',
				updateData      : null,
				originalData    : null,
                loadingData     : true,
                IIdd            : null,
                role            : '',
                model: {
                    id         : null,
                    energy_company_name : '',
                    energy_company_id   : null,   
                    email      : '',
                    activate   : true
                },
                company_name    : [],
			}
		},
		methods: {
			edit_e() {
				if (this.edit) {
					this.edit = false
					this.restoreOriginalData()
				} else {
					this.setupFields()
					this.edit = true
				}
			},
			restoreOriginalData() {
				let model = {
					...this.originalData,
				}
                this.model = model
                console.log(this.model)
			},
			setupFields() {
                console.log('setup')
			},
			get_Data() {
				service.getBy(this.id)
					.then(data => {
						if (data.status == 'success') {
                            this.originalData   = data.notif
                            this.company_name    = data.energy_companies
							this.IIdd     = this.id
							this.loadingData    = false
							this.found          = true
							this.restoreOriginalData()	
                            this.subTitle       = this.originalData.energy_company_name
							this.role           = data.role
						}else {
                            this.$swal(data.status, data.message, data.status)
                            this.loadingData = false
                            return
                        }
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			},
			okToUpdate() {
                if (this.model.energy_company_id === undefined || this.model.energy_company_id===null) {
                    this.$swal('Alert!', 'Energy Company not selected', 'warning')
                    return false
                } else if (this.model.email === undefined || this.model.email == '') {
                    this.$swal('Alert!', 'Email can not be empty', 'warning')
                    return false
                } 
				return true
			},
            update () {
                if (!this.okToUpdate()) {
					return
                }
				service.update(this.IIdd, this.model)
					.then((data) => {
						this.$swal(data[0], data[1], data[0])
							.then((result) => {
								this.get_Data()
							})
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
					})
					this.edit=false
			},
			delete_d(item) {
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to delete this " + this.$options.name + "?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						service.delete(this.IIdd)
							.then(data => {
								this.$swal(data[0], data[1], data[0])
								if (data[0] == 'success') {
									this.$router.replace('/request_haul_notifications')
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
            },
		    isLowerCaseEmail: function(evt) {
			    evt = (evt) ? evt : window.event;
        	    var charCode = (evt.which) ? evt.which : evt.keyCode;
			    if ((charCode >= 48 && charCode <= 57) || (charCode >= 97 && charCode <= 122)) {
				    return true
			    } else {
				    if ((charCode == 45) || (charCode == 46) || (charCode == 64) || (charCode == 95) || (charCode == 8) ||  (charCode == 9)) {
					    return true
				    } else {
					    evt.preventDefault();
          		    }
			    }
      	    },
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/request_hauls/notification.vue